import { useTranslationInterface } from 'utils/hooks/useTranslation';

export const useFbcaTranslations = () => useTranslationInterface('fbca');
